import { get, post } from '../request'

export const getStockrooms = (pagination) =>
  get('api/stockrooms', {
    populate: ['project'],
    pagination,
  })

export const createStockroom = (params) => post('api/stockrooms', params)
